import Tag from '@lyra/core/components/Tag'
import Tooltip from '@lyra/core/components/Tooltip'
import { InstrumentType } from '@lyra/web/constants/instruments'
import { YieldTokenConfig, YieldTokenId } from '@lyra/web/constants/yield'
import { formatMarketSymbol } from '@lyra/web/utils/markets'
import { formatTokenSymbol } from '@lyra/web/utils/tokens'
import { getYieldTokenConfig } from '@lyra/web/utils/yield'

type Props = {
  yieldId: YieldTokenId
  isLarge?: boolean
}

const getTooltipCopy = (config: YieldTokenConfig) => {
  switch (config.strategyId) {
    case 'CoveredPutSpread':
    case 'LongPrincipalProtected':
      return `This vault uses ${formatTokenSymbol(config.collateralId)} yield to get long ${
        config.marketId
      }. Earn more ${formatTokenSymbol(config.collateralId)} when the price of ${
        config.marketId
      } goes up.`
    case 'BasisTrade':
      return `This vault retains 1:1 exposure to ${formatTokenSymbol(
        config.collateralId
      )} while earning ${formatMarketSymbol(
        config.marketId,
        InstrumentType.Perps
      )} funding and double the partner points. `
    case 'CoveredCallSpread':
    case 'CoveredCalls':
      return `This vault sells ${
        config.marketId
      } upside every week to harvest 10-30% APY. Earn more ${formatTokenSymbol(
        config.collateralId
      )} when the price of ${config.marketId} trends sideways.`
  }
}

const getTooltipTitle = (config: YieldTokenConfig) => {
  switch (config.strategyId) {
    case 'CoveredPutSpread':
    case 'LongPrincipalProtected':
    case 'BasisTrade':
      return `Bullish ${config.marketId}`
    case 'CoveredCallSpread':
    case 'CoveredCalls':
      return `Trending ${config.marketId}`
  }
}

export const YieldStrategyTag = ({ yieldId, isLarge }: Props) => {
  const config = getYieldTokenConfig(yieldId)
  return (
    <Tooltip
      title={getTooltipTitle(config)}
      content={getTooltipCopy(config)}
      trigger={<Tag cursor="help" isLarge={isLarge} label={getTooltipTitle(config)} />}
    />
  )
}
